// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3vSVg","content":"GlobalSearch_content__1akmD"};